import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b0d88322&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b0d88322&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d88322",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/www-root/data/www/view.sessiondesign.ru/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0d88322')) {
      api.createRecord('b0d88322', component.options)
    } else {
      api.reload('b0d88322', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b0d88322&scoped=true", function () {
      api.rerender('b0d88322', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/front/shared/components/Tinymce/index.vue"
export default component.exports